import type { DataGridDataRowTemplateProps, RowTemplateType } from '@myosh/odin-components';
import type { MutableRefObject, ReactNode } from 'react';
import { AdminTabs } from '../../pages/admin/admin-utils';
import type { ActiveRecordRef } from '../active-record/active-record.component';

interface OdinDataGridLinkedUsersRowTemplateProps {
  activeRecordReference?: MutableRefObject<ActiveRecordRef | null | undefined>;
  isClickable?: boolean;
  triggerDefaultRowClickedEvent?: boolean;
  successCallback?: () => void;
}

export function OdinDataGridLinkedUsersRowTemplate({
  activeRecordReference,
  isClickable = true,
  triggerDefaultRowClickedEvent = false,
  successCallback,
}: OdinDataGridLinkedUsersRowTemplateProps) {
  const rowTemplate: RowTemplateType = (
    props: DataGridDataRowTemplateProps,
    children: ReactNode | Array<ReactNode>
  ) => {
    if (isClickable) {
      const details = props.data.fullName as string;
      const id = props.data.id as string;
      return (
        <div
          className="flex w-full cursor-pointer p-px"
          onClick={(event) => {
            if (triggerDefaultRowClickedEvent) {
              props.onRowClicked(event);
            }
            const isFullScreen = activeRecordReference?.current?.isFullScreen?.() ?? false;
            activeRecordReference?.current?.addActiveRecord(id, 'USER', details, isFullScreen, {
              userId: id,
              title: details,
              administrationTab: AdminTabs.USERS,
              onLinkedUserSuccessCallback: successCallback,
            });
          }}
        >
          {children}
        </div>
      );
    } else {
      return <>{children}</>;
    }
  };

  return rowTemplate;
}
